export const GET_LOAD_DATA_OF_COURSE = 'GET_LOAD_DATA_OF_COURSE';
export const GET_INIT_DATA = 'GET_INIT_DATA';


